import { GridColDef } from "@mui/x-data-grid-pro";
import ItemStatus from "../../../../../../common/components/item_status";
import { IconButton } from "@mui/material";
import DynamicIcon from "../../../../../../common/components/dynamic_icon";


type Props = {
    onActionEdit: (idContrato: number | null, openState: boolean) => void,
    onActionDelete: (idContrato: number | null, openState: boolean) => void,
}

export const GenerateFinanceiroContratosListaColumns = ({
    onActionEdit,
    onActionDelete,

}: Props): GridColDef[] => {

    const computeItemStatusTitle = (status: number) => {
        switch (status) {
            case 0:
                return "EA"; // EM Andamento
            case 1: // Finalizada
                return "F";
            case 2: // Cancelado
                return "C";
            case 3: // Paralisado
                return "P";
            default:
                return "?";
        }
    };

    const computeItemStatusColor = (status: number) => {
        switch (status) {
            case 0:
                return "gray";
            case 1:
                return "green";
            case 2:
                return "red";
            case 3:
                return "yellow";
            default:
                return "blue";
        }
    };

    const computeItemStatusDescription = (status: number) => {
        switch (status) {
            case 0: // EM ABERTO
                return "Contrato em andamento";
            case 1: // PAGO
                return "Contrato finalizado";
            case 2: // OUTROS
                return "Contrato cancelado";
            case 3: // EM ABERTO
                return "Contrato paralisado";
            default:
                return "?";
        }
    };


    return [
        {
            field: "status",
            filterable: false,
            headerName: "Status",
            minWidth: 50,
            width: 50,
            sortable: false,
            renderCell: (params) => (
                <div className="w-full h-full flex justify-center items-center">
                    <ItemStatus
                        size="autowidth"
                        textSize="small"
                        title={computeItemStatusTitle(params.value)}
                        color={computeItemStatusColor(params.value)}
                        description={computeItemStatusDescription(params.value)} />
                </div>
            )
        },
        {
            field: "codigo",
            filterable: false,
            headerName: "Código",
            flex: 1,
            minWidth: 55,
            maxWidth: 55,
            sortable: false,
            align: "center",
            headerAlign: "center",
            renderCell: (params) => (
                <div className="w-full h-full flex justify-center items-center">
                    {params.value}
                </div>
            )
        },
        {
            field: "descricao",
            filterable: false,
            headerName: "Descrição",
            flex: 1,
            minWidth: 150,
            sortable: false,
            renderCell: (params) => (
                <div className="w-full h-full flex break-normal" >
                    {params.value}
                </div>
            )
        },
        {
            field: "nomeCentroCusto",
            filterable: false,
            headerName: "Centro Custo",
            flex: 1,
            minWidth: 150,
            sortable: false,
            renderCell: (params) => (
                <div className="w-full h-full flex break-normal" >
                    {params.value}
                </div>
            )
        },

        {
            field: "nomeCliente",
            filterable: false,
            headerName: "Cliente",
            flex: 1,
            minWidth: 150,
            sortable: false,
            renderCell: (params) => (
                <div className="w-full h-full flex break-normal" >
                    {params.value}
                </div>
            )
        },

        {
            field: "unidade",
            filterable: false,
            headerName: "Unidade",
            minWidth: 60,
            width: 60,
            sortable: false,
            renderCell: (params) => (
                <div className="w-full h-full flex justify-center items-center">
                    {params.value}
                </div>
            )
        },
        {
            field: "dataInicio",
            filterable: false,
            headerName: "Data Inicio",
            maxWidth: 80,
            sortable: false,
            valueFormatter: (params) => {
                if (!params) return "";
                return new Intl.DateTimeFormat("pt-BR", {
                    day: "2-digit",
                    month: "2-digit",
                    year: "numeric",
                }).format(new Date(params));
            },
        },
        {
            field: "dataTermino",
            filterable: false,
            headerName: "Data Término",
            maxWidth: 80,
            sortable: false,
            valueFormatter: (params) => {
                if (!params) return "";
                return new Intl.DateTimeFormat("pt-BR", {
                    day: "2-digit",
                    month: "2-digit",
                    year: "numeric",
                }).format(new Date(params));
            },
        },
        {
            field: "valorVenda",
            filterable: false,
            headerName: "Valor Venda",
            width: 120,
            maxWidth: 120,
            sortable: false,
            valueFormatter: (params) => {
                if (params == null) return "";
                return new Intl.NumberFormat("pt-BR", {
                    style: "currency",
                    currency: "BRL",
                }).format(params);
            },
        },
        {
            field: "valorTotal",
            filterable: false,
            headerName: "Valor Financiado com a construtora",
            minWidth: 120,
            width: 120,
            sortable: false,
            valueFormatter: (params) => {
                if (params == null) return "";
                return new Intl.NumberFormat("pt-BR", {
                    style: "currency",
                    currency: "BRL",
                }).format(params);
            },
        },
        {
            field: "valorGlobal",
            filterable: false,
            headerName: "Valor Global do Contrato",
            minWidth: 120,
            width: 120,
            sortable: false,
            valueFormatter: (params) => {
                if (params == null) return "";
                return new Intl.NumberFormat("pt-BR", {
                    style: "currency",
                    currency: "BRL",
                }).format(params);
            },
        },
        {
            field: "valorSaldo",
            filterable: false,
            headerName: "Valor Saldo Devedor",
            width: 120,
            minWidth: 120,
            sortable: false,
            valueFormatter: (params) => {
                if (params == null) return "";
                return new Intl.NumberFormat("pt-BR", {
                    style: "currency",
                    currency: "BRL",
                }).format(params);
            },
        },
        {
            field: "criadoPor",
            filterable: false,
            headerName: "Criado Por",
            maxWidth: 100,
            sortable: false,
            renderCell: (params) => (
                <div className="w-full h-full flex break-normal" >
                    {params.value}
                </div>
            )
        },

        {
            field: 'idContratoFinanceiro',
            sortable: false,
            filterable: false,
            headerName: 'Ações',
            minWidth: 100,
            renderCell: (params) => {
                return (
                    <div className="flex items-center justify-center w-full h-full gap-2">

                        <IconButton onClick={() => onActionEdit(params.value, true)}>
                            <DynamicIcon nameIcon="EditRounded" size={25} className="dark:text-white text-primary-green" />
                        </IconButton>

                        <IconButton onClick={() => onActionDelete(params.value, true)}>
                            <DynamicIcon nameIcon="DeleteForeverRounded" size={25} className="text-red-500" />
                        </IconButton>
                    </div>
                );
            }
        }

    ];

}